/**
 * create chunks from the initial array
 * @param {Array} array
 * @param {Number} size
 */
export function chunk(array, size) {
    if (!Array.isArray(array)) {
      return [];
    }
    const result = [];
    const len = array.length;
    let i = 0;
    size = size || len;
    while (i < len) {
      result.push(array.slice(i, (i += size)));
    }
    return result;
  }